import { apiWithBody, apiWithQuery, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_EHRInstance, DBDef_EHRInstance } from '@app/org-shared';
import { filterInstances } from '@nu-art/ts-common';
import { ModuleFE_EHROrderConfiguration } from '../ehr-order-configuration/index.js';
export const dispatch_onEHRInstanceChanged = new ThunderDispatcherV3('__onEHRInstanceUpdated');
export class ModuleFE_EHRInstance_Class extends ModuleFE_BaseApi {
    _v1;
    __searchFilterMapper = (item) => [item.label];
    __searchGroups = (items) => ([{
            group: this.dbDef.entityName,
            results: filterInstances(items.map(i => ({ _id: i._id, uiLabel: i.label })))
        }]);
    constructor() {
        super(DBDef_EHRInstance, dispatch_onEHRInstanceChanged);
        this._v1 = {
            getEhrInstance: apiWithQuery(ApiDef_EHRInstance._v1.getEhrInstance),
            deleteInstance: apiWithBody(ApiDef_EHRInstance._v1.deleteInstance, this.onInstanceDeleted),
            syncOrdersFromPathways: apiWithBody(ApiDef_EHRInstance._v1.syncOrdersFromPathways, this.onOrdersSyncedFromPathways),
            copyOrderConfigsFromEhrInstance: apiWithBody(ApiDef_EHRInstance._v1.copyOrderConfigsFromEhrInstance, this.onOrdersSyncedFromPathways),
            getCertData: apiWithBody(ApiDef_EHRInstance._v1.getCertData),
            getQuaiEhrInstances: apiWithQuery(ApiDef_EHRInstance._v1.getQuaiEhrInstances),
        };
    }
    onInstanceDeleted = async (response) => {
        await ModuleFE_EHROrderConfiguration.onEntriesDeleted(response.ehrOrders);
        await this.onEntryDeleted(response.instance);
    };
    onOrdersSyncedFromPathways = async (response) => {
        await ModuleFE_EHROrderConfiguration.onEntriesUpdated(response.orderConfigs);
    };
}
export const ModuleFE_EHRInstance = new ModuleFE_EHRInstance_Class();
//# sourceMappingURL=ModuleFE_EHRInstance.js.map